import { useEffect, useState } from 'react';
import { appEnv } from './_env';

const getGtmId = () => {
   if (process.env.NODE_ENV === 'development') return '';
   if (appEnv.isAppRisk) return 'G-RJ06TYRM51';
   return '';
};

export const useGtmScript = () => {
   const [isLoaded, setIsLoaded] = useState(false);
   useEffect(() => {
      const id = getGtmId();
      if (!id) return;
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
      script.async = true;
      script.addEventListener('load', () => {
         setIsLoaded(true);
      });
      document.body.append(script);
      return () => {
         script.remove();
      };
   }, []);

   useEffect(() => {
      if (isLoaded) {
         // @ts-ignore
         window.dataLayer = window.dataLayer || [];
         function gtag() {
            // @ts-ignore
            // eslint-disable-next-line prefer-rest-params
            window.dataLayer.push(arguments);
         }
         // @ts-ignore
         gtag('js', new Date());
         // @ts-ignore
         gtag('config', getGtmId());
      }
   }, [isLoaded]);
   return isLoaded;
};
